const STORAGE_KEY = "expense";
const HISTORY_KEY = "expense_history";

export function has() {
  return Boolean(localStorage.getItem(STORAGE_KEY));
}

export function set(state) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function get() {
  if (has()) {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY));
    } catch (error) {
      return null;
    }
  }
}

export function reset() {
  localStorage.removeItem(STORAGE_KEY);
}

// ── History ──

export function getHistory() {
  try {
    return JSON.parse(localStorage.getItem(HISTORY_KEY)) || [];
  } catch {
    return [];
  }
}

export function addToHistory(expense) {
  // Only archive if it has meaningful data (at least one item with a name or price)
  const hasData = expense.items.some((i) => i.name.trim() || i.price > 0);
  if (!hasData) return;

  const entry = {
    ...expense,
    archivedAt: new Date().toISOString(),
  };
  const history = getHistory();
  history.unshift(entry); // newest first
  localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
}

export function deleteHistoryEntry(index) {
  const history = getHistory();
  history.splice(index, 1);
  localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
}
